module.exports = __webpack_public_path__ + "static/media/bunu_jump_run.1267330e.png";